/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
	selector: "globalictcc-uploaded-file-status",
	standalone: true,
	imports: [],
	templateUrl: "./uploaded-file-status.component.html",
	styleUrl: "./uploaded-file-status.component.scss"
})
export class UploadedFileStatusComponent implements ICellRendererAngularComp {
	public isUploaded: boolean = false;

	/**
	 * Initializes the cell renderer with the provided parameters.
	 * Sets the `isUploaded` property based on the `uploaded` field in the row data.
	 *
	 * @param params - The parameters supplied by the ag-Grid cell renderer, containing row data and other context.
	 */
	public agInit(params: ICellRendererParams) {
		this.isUploaded = !!params.data?.uploaded;
	}

	public refresh(): boolean {
		return true;
	}
}
